import React from 'react'
import {Perifoneos} from "../components/marketing/Perifoneos";

export const PerifoneosPage = () => {
    return (
        <Perifoneos/>
    )
}
